var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0L30.6038 0C32.7742 0 34.8514 0.881852 36.359 2.44324L49.7552 16.3179C51.1952 17.8093 52 19.8015 52 21.8747V51C52 54.866 48.866 58 45 58H7C3.13401 58 0 54.866 0 51V7Z",
    fill: "#66CDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9862 36.16C18.2582 36.16 17.1382 35.36 16.4022 34.352L17.6982 33.008C18.3542 33.856 19.0102 34.336 19.9542 34.336C21.0102 34.336 21.7302 33.632 21.7302 32.128V24.8H23.7622V32.192C23.7622 33.52 23.3622 34.512 22.7062 35.168C22.0502 35.824 21.1062 36.16 19.9862 36.16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0593 36.16C28.3473 36.16 26.7313 35.568 25.3873 34.368L26.5713 32.96C27.6433 33.888 28.7313 34.416 30.1073 34.416C31.3233 34.416 32.0913 33.84 32.0913 33.008V32.976C32.0913 32.176 31.6433 31.744 29.5633 31.264C27.1793 30.688 25.8353 29.984 25.8353 27.92V27.888C25.8353 25.968 27.4353 24.64 29.6593 24.64C31.2913 24.64 32.5873 25.136 33.7233 26.048L32.6673 27.536C31.6593 26.784 30.6513 26.384 29.6273 26.384C28.4753 26.384 27.8033 26.976 27.8033 27.712V27.744C27.8033 28.608 28.3153 28.992 30.4753 29.504C32.8433 30.08 34.0593 30.928 34.0593 32.784V32.816C34.0593 34.912 32.4113 36.16 30.0593 36.16Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsIcon);
export default __webpack_public_path__ + "static/media/js-icon.2b6595eff2cf7af4df95c3cbd9b00687.svg";
export { ForwardRef as ReactComponent };